{
  "CANNED_MGMT": {
    "HEADER": "Připravené odpovědi",
    "LEARN_MORE": "Další informace o předpřipravených odpovědích",
    "DESCRIPTION": "Předpřipravené odpovědi jsou předem napsané šablony odpovědí, které vám pomáhají rychle reagovat na konverzaci. Agenti mohou napsat znak '/' následovaný zkratkou pro vložení předpřipravené odpovědi během konverzace.",
    "HEADER_BTN_TXT": "Přidat předpřipravenou odpověď",
    "LOADING": "Načítání předpřipravených odpovědí...",
    "SEARCH_404": "Neexistují žádné položky odpovídající tomuto dotazu.",
    "LIST": {
      "404": "V tomto účtu nejsou k dispozici žádné předpřipravené odpovědi.",
      "TITLE": "Spravovat předpřipravené odpovědi",
      "DESC": "Předpřipravené odpovědi jsou předem definované šablony odpovědí, které lze použít k rychlému odesílání odpovědí na konverzace.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Krátký kód",
        "CONTENT": "Obsah",
        "INBOXES": "Schránky",
        "ACTIONS": "Akce"
      },
      "ALL_INBOXES": "Všechny schránky",
      "FILTER": {
        "ALL_INBOXES": "Všechny schránky",
        "NO_INBOX": "Bez schránky",
        "SEARCH_PLACEHOLDER": "Hledat schránky"
      }
    },
    "ADD": {
      "TITLE": "Přidat předpřipravenou odpověď",
      "DESC": "Předpřipravené odpovědi jsou předem definované šablony odpovědí, které lze použít k rychlému odesílání odpovědí na konverzace.",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Krátký kód",
          "PLACEHOLDER": "Zadejte krátký kód.",
          "ERROR": "Krátký kód je povinný."
        },
        "SUBJECT": {
          "LABEL": "Předmět (pouze e-mail)",
          "PLACEHOLDER": "Volitelný předmět pro e-mailové odpovědi / nové konverzace"
        },
        "CONTENT": {
          "LABEL": "Zpráva",
          "PLACEHOLDER": "Napište zprávu, kterou chcete uložit jako šablonu pro pozdější použití.",
          "ERROR": "Zpráva je povinná."
        },
        "ATTACHMENTS": {
          "LABEL": "Přílohy"
        },
        "INBOXES": {
          "LABEL": "Schránky",
          "PLACEHOLDER": "Vyberte schránky (volitelné, ponechte prázdné pro všechny schránky)"
        },
        "SUBMIT": "Odeslat"
      },
      "API": {
        "SUCCESS_MESSAGE": "Předpřipravená odpověď byla úspěšně přidána.",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "EDIT": {
      "TITLE": "Upravit předpřipravenou odpověď",
      "CANCEL_BUTTON_TEXT": "Zrušit",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Krátký kód",
          "PLACEHOLDER": "Zadejte krátký kód.",
          "ERROR": "Krátký kód je povinný."
        },
        "SUBJECT": {
          "LABEL": "Předmět (pouze e-mail)",
          "PLACEHOLDER": "Volitelný předmět pro e-mailové odpovědi / nové konverzace"
        },
        "CONTENT": {
          "LABEL": "Zpráva",
          "PLACEHOLDER": "Napište zprávu, kterou chcete uložit jako šablonu pro pozdější použití.",
          "ERROR": "Zpráva je povinná."
        },
        "ATTACHMENTS": {
          "LABEL": "Přílohy"
        },
        "INBOXES": {
          "LABEL": "Schránky",
          "PLACEHOLDER": "Vyberte schránky (volitelné, ponechte prázdné pro všechny schránky)"
        },
        "SUBMIT": "Odeslat"
      },
      "BUTTON_TEXT": "Upravit",
      "API": {
        "SUCCESS_MESSAGE": "Předpřipravená odpověď byla úspěšně aktualizována.",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazat",
      "API": {
        "SUCCESS_MESSAGE": "Předpřipravená odpověď byla úspěšně smazána.",
        "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
      },
      "CONFIRM": {
        "TITLE": "Potvrdit smazání",
        "MESSAGE": "Opravdu chcete odstranit ",
        "YES": "Ano, smazat ",
        "NO": "Ne, zachovat "
      }
    }
  }
}
